import util from '@bmp-vue/core/api/util'
const controller = 'Capitaldegiro'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  AllowedDates (th, value) {
    return ![0, 6].includes(th.$api.UI.Parse.Date(value).getDay())
  },
  saveProposta (th, callback) {
    const dtoPessoa = {
      dto: {
        Nome: th.model.Pessoa.Nome,
        DocumentoFederal: th.model.Pessoa.DocumentoFederal,
        PessoaDadosContato: {
          Email: th.model.Pessoa.PessoaDadosContato.Email,
          TelefoneFixo1: th.model.Pessoa.PessoaDadosContato.TelefoneFixo1,
          TelefoneCelular1: th.model.Pessoa.PessoaDadosContato.TelefoneCelular1,
        }
      }
    }
    const dtoEndereco = {
      dto: {
        CEP: th.model.Pessoa.PessoaEndereco.CEP,
        Logradouro: th.model.Pessoa.PessoaEndereco.Logradouro,
        NroLogradouro: th.model.Pessoa.PessoaEndereco.NroLogradouro,
        Bairro: th.model.Pessoa.PessoaEndereco.Bairro,
        Complemento: th.model.Pessoa.PessoaEndereco.Complemento,
        Cidade: th.model.Pessoa.PessoaEndereco.Cidade,
        UF: th.model.Pessoa.PessoaEndereco.UF,
      },
      param: { DocumentoCliente: th.model.Pessoa.DocumentoFederal }
    }
    const dtoProposta = {
      dto: {
        DocumentoCliente: th.$api.UI.Format.SomenteAlfanumerico(th.model.Pessoa.DocumentoFederal),
        CodigoOperacao: th.model.CodigoOperacao,
        VlrSolicitado: th.model.VlrSolicitado,
        Prazo: th.model.Parcela.Prazo,
        PercJurosNegociado: th.model.Parcela.PercJurosMensal,
        VlrIOF: th.model.Parcela.VlrIOF,
        PercIOF: th.model.Parcela.PercIOF,
        VlrParcela: th.model.Parcela.VlrParcela,
        VlrTAC: th.model.Parcela.VlrTAC,
        DtPrimeiroVencto: th.model.DtPrimeiroVencto,
        DocumentoParceiroCorrespondente: th.$api.UI.Format.SomenteAlfanumerico(th.$empresa.documentoFederal)
      },
    }

    th.$api.Multiplo.Post('CreateUpdatePessoa', dtoPessoa).then(function (pessoa) {
      if (th.$api.UI.PostLoadData(pessoa, true)) {
        th.$api.Multiplo.Post('CreateUpdatePessoaEndereco', dtoEndereco).then(function (endereco) {
          if (th.$api.UI.PostLoadData(endereco, true)) {
            th.$api.Multiplo.Post('IncluirPropostaManualSimplificado', dtoProposta).then(function (proposta) {
              if (th.$api.UI.PostLoadData(endereco, true)) {
                th.$set(th.model, 'CodigoProposta', proposta.Codigo)
                callback()
              }
            })
          }
        })
      }
    })
  }
})

export default ctrl
